import React, { useEffect, useState } from "react";
import Navbar from "../../Navbar";
import Sidebar from "../../Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Config from "../../Config";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../../useAuthhandling';
import Deletemodal from "../../Deletemodal";

function Level3list() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const location = useLocation();
  let navigate = useNavigate();
  let { id } = useParams();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [servicedata, setServicedata] = useState([]);
  const [servicedata3, setServicedata3] = useState([]);
  const [levelsdata, setLevelsdata] = useState([]);

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }
  
  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=4`,
      {
        method: "POST",
        body: JSON.stringify({
          levelOneCategory: location.state.levelsdata.levelOneId,
          levelTwoCategory: location.state.levelsdata.levelTwoId,
          levelThreeCategory: id,
        }),

        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();
      setLevelsdata({
        levelOneId: data.data[0].levelOneId,
        levelOnename: data.data[0].levelOneName,
        levelTwoId: data.data[0].levelTwoId,
        levelTwoname: data.data[0].levelTwoName,
        levelThreeName: data.data[0].levelThreeName,
        levelThreeId: data.data[0].levelThreeId,
      });
      setServicedata3(data.data[0].subcategories);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    
    else {
      alert("error");

      
    }
  };

  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/delete-service-category/${id}`,
      {
        method: "PUT",

        body: JSON.stringify({
          categoryLevel: 4,
          levelOneCategory: levelsdata.levelOneId,
          levelTwoCategory: levelsdata.levelTwoId,
          levelThreeCategory: levelsdata.levelThreeId,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",

          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      const deletedata = await response.json();

      toast.success("Sucessfully deleted", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      getinfo();
    }
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    
    else {
      console.log("error");

    }
  };
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-12 navigation-content">
                <Link to="/subcategorylist" className="naviga">
                  {" "}
                  Category list
                </Link>
                {">>"}
                <Link
                  className="naviga"
                  to={`/level1/${levelsdata.levelOneId}`}
                  state={{
                    levelsdata,
                  }}
                >
                  {levelsdata.levelOnename}
                </Link>
                {">>"}
                <Link
                  className="naviga"
                  to={`/level2/${levelsdata.levelTwoId}`}
                  state={{
                    levelsdata,
                  }}
                >
                  {levelsdata.levelTwoname}
                </Link>
                {">>"}
                <p className="naviga1">{levelsdata.levelThreeName}</p>
              </div>
            </div>
            {servicedata3.length > 0 ? (
              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">
                        {servicedata.levelThreeName} category (Level 4 list)
                      </h4>
                      <div className="table-responsive pt-3">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Category Name</th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="catlist">
                            {servicedata3.map((cat, index) => {
                              return (
                                <tr key={index}>
                                  <td>{cat.categoryName}</td>

                                  <td c="actions_td">
                                    <Link
                                      // onClick={() => deleteservice(cat._id)}
                                      onClick={() => tog_animationFlip(cat._id)}

                                      className="margins-2 action_icons"
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </Link>
                                  
                                      <Link
                                        to={"/editsubcategory/" + cat._id}
                                        state={{
                                          levelsdata,
                                          level: 4,
                                        }}
                                        className="fa-solid fa-pen action_icons"
                                    
                                      ></Link>
                                    

                                    <Link to={"/subcategoryview/" + cat._id} 
                                    state={{
                                      levelsdata,
                                      level: 4,
                                    }}
                                   className="action_icons" >
                                             <i className="fa-solid fa-eye" />
                                             </Link>
                                    <ToastContainer />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <h4 className="text-center" style={{ fontSize: "18px" }}>
                    No Data Found
                  </h4>
                </div>
              </div>
            )}
          </div>
        </div>

        {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Level four category"}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
export default Level3list;
